<template>
<div class="top-left-wrapper">
 <div  class="top-left"></div>
</div>
</template>

<script>
export default {
name: "OrdersTopLeft"
}
</script>

<style scoped>
.top-left-wrapper{
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
  width: calc(44%);
}
</style>